(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-text-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    class ImageTextCarousel extends HTMLElement {
      constructor() {
        super();
        this.currentIndex = 0;
        this.autoplayInterval = null;
      }

      connectedCallback() {
        // Get ID from data attribute - much more reliable
        const id = this.dataset.carouselId;

        this.imageSelector = `.ai-image-text-carousel__image-${id}`;
        this.indicatorSelector = `.ai-image-text-carousel__indicator-${id}`;

        this.images = this.querySelectorAll(this.imageSelector);
        this.indicators = this.querySelectorAll(this.indicatorSelector);
        this.interval = parseInt(this.dataset.interval) * 1000;
        this.autoplay = this.dataset.autoplay === 'true';

        // console.log('ImageTextCarousel initialized', {
        //   id,
        //   imageCount: this.images.length,
        //   indicatorCount: this.indicators.length,
        //   interval: this.interval,
        //   autoplay: this.autoplay
        // });

        if (this.images.length > 1) {
          if (this.indicators.length > 0) {
            this.setupIndicators();
          }
          if (this.autoplay) {
            this.startAutoplay();
          }
        }
      }

      setupIndicators() {
        this.indicators.forEach((indicator) => {
          indicator.addEventListener('click', () => {
            const index = parseInt(indicator.dataset.index);
            this.goToSlide(index);
            if (this.autoplay) {
              this.resetAutoplay();
            }
          });
        });
      }

      goToSlide(index) {
        this.images.forEach((img) => img.classList.remove('active'));
        if (this.indicators.length > 0) {
          this.indicators.forEach((ind) => ind.classList.remove('active'));
          this.indicators[index].classList.add('active');
        }

        this.images[index].classList.add('active');
        this.currentIndex = index;
      }

      nextSlide() {
        const nextIndex = (this.currentIndex + 1) % this.images.length;
        this.goToSlide(nextIndex);
      }

      startAutoplay() {
        this.autoplayInterval = setInterval(() => {
          this.nextSlide();
        }, this.interval);
      }

      resetAutoplay() {
        clearInterval(this.autoplayInterval);
        this.startAutoplay();
      }

      disconnectedCallback() {
        if (this.autoplayInterval) {
          clearInterval(this.autoplayInterval);
        }
      }
    }

    if (!customElements.get('image-text-carousel')) {
      customElements.define('image-text-carousel', ImageTextCarousel);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
